<template name="pay">
  <div class="pay">
    <div class="account-act-header flex-cm">
      <img src="https://assets.pfotoo.com/pc/img/downall.svg" style="width:21px;height:21px;margin-right:10px;"/>
      <div class="white-font font-size18">下载全部</div>
    </div>
    <div class="account-act-body">
      <!--
      <div class="black-font font-size16">点击下面按钮联系客服，下载全部投稿</div>
      <div class="account-buttons white-font font-size14 flex-lm">
        <a class="account-wx-button account-button flex-cm white-font" href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B" target="_blank" style="background: #3DC4A7;">
          <img  src="https://assets.pfotoo.com/pc/img/chat-white.svg" style="width:16px;margin-right: 5px;"/>
          <div>联系客服</div>
        </a>
        <!-- <div class="account-wb-button account-button flex-cm">微博头条文章授权</div> -->
      <!--</div>-->
      <pre class="account-info">
        <b style="font-size: 16px;">1、下载全部投稿，如何收费？</b>

        原价<s>30元/1G</s> 活动价10元/1G，
        原价<s>3元/100M</s>，活动价1元/100M。

        帮助推广Fotoo，可兑换收费服务，联系客服咨询。
        付款后不支持退款，敬请谅解。
        友情提示，请在必须全部下载时使用该付费服务。
        如果下载的目的是评选作品，可通过邀请协作完成，无需下载全部投稿。

        <b style="font-size: 16px;">2、如何下载全部投稿？</b>

        ①扫右侧二维码付款后，<b style="color:#3DC4A7;font-weight: bold;">添加人工客服企业微信</b>发送付款截图+活动名称

        ②等待客服返回下载链接（大概需要30分钟）：客服将在后台打包生成下载链接，发送给你

        ③收到下载链接后，完整复制链接内容（包括文字）， 在浏览器打开下载

        <b style="color:#3DC4A7;font-weight: bold;">说明一下：
        1）下载链接30分钟内有效，请及时完成下载
        2）官方后台下载的是原文件：用户上传的是什么文件下载后就是什么文件
        3）自行下载可选原文件或压缩文件</b>

        <b style="font-size: 16px;">3、服务支持时间？</b>

        仅工作日10：00~17：00支持付费下载全部投稿

        <b style="font-size: 16px;">4、如何反馈更多下载需求？</b>

        联系客服，说明你下载投稿的目的，以便我们将持续改进下载服务。
      </pre>
      <div class="pay-images">
        <img src="https://assets.pfotoo.com/images/qiye.png" class="pay-code qiye"/>
        <img src="https://assets.pfotoo.com/wxpay.jpg" class="pay-code"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pay',
    data () {
      return {

      }
    }
  }
</script>

<style>
  .pay{
    width: 100%;
    min-width: 1326px;
  }
  .pay-images{
    position: absolute;
    left: 850px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 242px;
    height: 577px;
    opacity: 1;
  }
  .pay-code{
    width: 186px;
    height: 253px;
    opacity: 1;
    margin-bottom: 82px;
  }
  .pay-code.qiye{
    width: 211px;
    height: 242px;
    opacity: 1;
  }
  .account-act-header{
    width:100%;
    height:80px;
    background: #1A2E3B;
    margin-bottom: 40px;
  }
  .account-act-body{
    width:100%;
    padding-left:80px;
    box-sizing: border-box;
    position: relative;
  }
  .account-buttons{
    padding-top: 20px;
  }
  .account-button{
    padding:0 10px;
    height:36px;
    border-radius:5px;
    margin-right:40px;
    cursor: pointer;
  }
  .account-wx-button{
    background: #3DC4A7;
    text-decoration: none;
  }
  .account-wb-button{
    background:#353535
  }
  .account-info{
    width:100%;
    padding-top:20px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 400;
    text-align: left;
    color: #353535;
    line-height: 22px;
  }
  .account-info-title{
    width:100%;
    padding-bottom:10px;
  }
  .account-info-detail{
    width:100%;
    padding-bottom:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pay.vue